import React, { useEffect } from 'react'

import { LazyRender } from 'conversations/components/LazyRender'
import {
  feedbackModalOpen,
  onBoardingV2ModalOpen,
  sidebarPreferencesModalOpen,
} from 'conversations/modules/modal/selectors'
import { getPreference, preferencesLoaded } from 'conversations/modules/user/selectors'
import { lazyRetry } from 'conversations/utils/rendering/LazyRetryRender'
import { useDispatch, useSelector } from 'react-redux'
import { showOnBoardingV2Modal } from 'shared/store/actions/modal'

const UpdateVersionModal = lazyRetry(() => import('conversations/components/UpdateVersionModal'))
const OnBoardingV2Modal = lazyRetry(() => import('conversations/components/OnBoardingV2Modal'))
const FeedbackModal = lazyRetry(() => import('conversations/components/FeedbackModal'))

const SidebarPreferencesModal = lazyRetry(
  () => import('conversations/components/NewChatSidebar/SidebarPreferencesModal')
)

const useMaybeOnBoardingModal = () => {
  const dispatch = useDispatch()
  const prefLoaded = useSelector(preferencesLoaded)
  const onBoardingV2Dismissed = useSelector(getPreference('onBoardingV2Dismissed'))
  const isOnConversations = !window.location.pathname.includes('prospector')

  useEffect(() => {
    if (isOnConversations && prefLoaded) {
      !onBoardingV2Dismissed && dispatch(showOnBoardingV2Modal())
    }
  }, [dispatch, isOnConversations, onBoardingV2Dismissed, prefLoaded])
}

const AppModals = () => {
  const onboardingV2Open = useSelector(onBoardingV2ModalOpen)
  const feedbackOpen = useSelector(feedbackModalOpen)
  const sidebarPreferencesOpen = useSelector(sidebarPreferencesModalOpen)

  useMaybeOnBoardingModal()

  return (
    <>
      {onboardingV2Open && (
        <LazyRender>
          <OnBoardingV2Modal />
        </LazyRender>
      )}
      {feedbackOpen && (
        <LazyRender>
          <FeedbackModal />
        </LazyRender>
      )}
      {sidebarPreferencesOpen && (
        <LazyRender>
          <SidebarPreferencesModal />
        </LazyRender>
      )}
      <UpdateVersionModal />
    </>
  )
}

export default AppModals
